import { Link } from 'react-router-dom';
import * as styles from './AccessDeniedPage.css';

export const AccessDeniedPage = () => {
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>403 - Access Denied</h1>
            <p>You don`t have permissions to access the resource.</p>
            <Link to={`/`}>Go back to Main</Link>
        </div>
    );
};
